export const defaultRTP = 97;
